import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import { LoggerService } from "../logger/logger.service";

@Injectable()
export class LogInterceptor implements HttpInterceptor {
  constructor(private logger: LoggerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const started = Date.now();
    let ok: string;

    return next.handle(req).pipe(
      tap(
        (event) => (ok = event instanceof HttpResponse ? "succeeded" : ""),
        (err) => (ok = "failed"),
      ),
      finalize(() => {
        const elapsed = Date.now() - started;
        const msg = `${req.method} "${req.urlWithParams}" ${ok} in ${elapsed} ms.`;
        this.logger.info("httpRequest", msg);
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/common/http/log-interceptor.ts